export function createAndLoadJsonFile(filename: string, data: any) {
  const node = document.createElement('a');
  const encodedData = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(data))}`;
  node.setAttribute('href', encodedData);
  node.setAttribute('download', `${filename}.json`);
  document.body.appendChild(node);
  node.click();
  node.remove();
}
